<div class="stats-blocks-wrapper">
	<div class="container">
		<div class="stats-block" *ngFor="let statsBlock of statsBlocks">
			<div class="count">
				<span *ngIf="statsBlock.procent">{{ statsBlock.metric }} %</span>
				<span *ngIf="!statsBlock.procent" [title]="statsBlock.metric" [innerHTML]="statsBlock.metric | numberWithLetter"></span>
			</div>
			<div class="title">
				{{ statsBlock.title | translate }}
			</div>
			<div class="trend">
				<span *ngIf="statsBlock.warningText">
					<bb-info icon="warning" [contents]="statsBlock.warningText"></bb-info>&nbsp;
				</span>

				<span [class]="statsBlock.class">
					<i *ngIf="statsBlock.arrow" class="fas" [ngClass]="statsBlock.arrow">&nbsp;</i>{{ statsBlock.trend }}{{ statsBlock.trend !== 'n/a' ? '%' : '' }}
				</span>
			</div>
		</div>
	</div>
</div>
